//TIP MUTATIONS
export const PUSH_TIP = "PUSH_TIP"
export const RESET_TIP = "RESET_TIP"
export const RESET_TIP_LIST = "RESET_TIP_LIST"
export const SET_TIP_LOADING = "SET_TIP_LOADING"
export const SET_TIP = "SET_TIP"
export const REMOVE_TIP = "REMOVE_TIP"

